import { useTranslation } from 'react-i18next'
import React from 'react'

import DateFilter from '../../../../components/filter/DateFilter'
import GroupsFilter from '../../../../containers/groups/filters/GroupsFilter'
import ProfilesFilter from '../../../../containers/profiles/filters/ProfilesFilter'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  const { t } = useTranslation('common')
  return (
    <ScreenViewFilterBar screen="users" open={open}>
      <ProfilesFilter />
      <GroupsFilter />
      <DateFilter label={t('createdAt')} field="insertedAt" />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
